import { jsx as _jsx } from "react/jsx-runtime";
import { InternationalProvider } from '@pltk/components';
import { RouterRoot } from './routes';
import { BackendProvider } from "@pltk/core";
import { EnabledWidgetProvider } from '@pltk/core';
export function LiveToolkitApp(props) {
    return _jsx(BackendProvider, Object.assign({ fileStorage: props.backend.fileStorage, client: props.backend.client, subscription: props.backend.subscription }, { children: _jsx(InternationalProvider, Object.assign({ language: props.language }, { children: _jsx(EnabledWidgetProvider, Object.assign({ widgets: props.plugins }, { children: _jsx(RouterRoot, {}) })) })) }));
}
